
import React, { useState } from 'react';
import { Row, Col, Card, CardBody, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Button, Spinner, FormFeedback } from 'reactstrap';

import ResponseBox from './ResponseBox';

import { patchUser } from '../../helpers/satiBack';
import useFormManager from '../../hooks/useFormManager';

const PersonalData = ({ user, updateUser }) => {
  const [errors, setErrors] = useState({});

  const {
    isLoading: loading,
    response,
    handleSubmit: submitForm
  } = useFormManager({
    onSubmit: (data) => patchUser(data),
    onSuccess: () => updateUser()
  });

  const {
    sexo: gender,
    estatura: height,
    peso: weight,
    fechaNacimiento: birthdate
  } = user;

  const heightNum = Number(height);

  const validate = (name, value) => {
    let error = "";
    if (name === "altura") {
      if (value < 50 || value > 250) error = "Altura debe estar entre 50 y 250 cm";
    }
    if (name === "peso") {
      if (value < 20 || value > 500) error = "Peso debe estar entre 20 y 500 kg";
    }
    setErrors(prev => ({ ...prev, [name]: error }));
    return !error;
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    validate(name, Number(value));
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    const { sexo, fechaNacimiento, altura, peso } = e.target.elements;
    
    const h = Number(altura.value);
    const w = Number(peso.value);

    const isHValid = validate("altura", h);
    const isWValid = validate("peso", w);

    if (!isHValid || !isWValid) return;

    const data = {
      sexo: sexo.value,
      fechaNacimiento: fechaNacimiento.value,
      estatura: h,
      peso: w
    };

    submitForm(data);
  }

  return (
    <Card>
      <CardBody>
        <h4>Datos Personales</h4>
        <Form className="mt-4" onSubmit={onFormSubmit}>
          <FormGroup>
            <Label for="personalSexo">Sexo</Label>
            <Input type="select" name="sexo" id="personalSexo" defaultValue={gender}>
              <option value="M">Hombre</option>
              <option value="F">Mujer</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="personalfechaNacimiento">Fecha de nacimiento</Label>
            <Input
              type="date"
              name="fechaNacimiento"
              id="personalfechaNacimiento"
              defaultValue={birthdate}
              max={new Date().toISOString().split("T")[0]}
            />
          </FormGroup>
          <FormGroup>
            <Label for="personalAltura">Altura</Label>
            <InputGroup>
              <Input 
                type="number" 
                name="altura" 
                id="personalAltura" 
                defaultValue={heightNum} 
                min="0" 
                max="250" 
                step="1"
                onChange={onInputChange}
                invalid={!!errors.altura}
              />
              <InputGroupAddon addonType='append'>
                <InputGroupText>cm</InputGroupText>
              </InputGroupAddon>
              <FormFeedback>{errors.altura}</FormFeedback>
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label for="personalPeso">Peso</Label>
            <InputGroup>
              <Input 
                type="number" 
                name="peso" 
                id="personalPeso" 
                defaultValue={weight} 
                min="0" 
                step="any"
                onChange={onInputChange}
                invalid={!!errors.peso}
              />
              <InputGroupAddon addonType='append'>
                <InputGroupText>kg</InputGroupText>
              </InputGroupAddon>
              <FormFeedback>{errors.peso}</FormFeedback>
            </InputGroup>
          </FormGroup>
          <ResponseBox type={response}/>
          <Row>
            <Col>
              <Button type="submit" color="primary" className="float-right" disabled={loading}>
                Guardar
                {loading && (<Spinner size="sm" color="light" className="ml-2"/>)}
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  )
}

export default PersonalData;
